import { getQueryParamValue } from "@chatfood/core-utils";
import { defineNuxtRouteMiddleware, abortNavigation, useError } from "nuxt/app";
import { useBugReporter, usePinia } from "#imports";
import { useOrderStore } from "~/stores/order";

const abortWithUnexpectedError = (
  message: string = "Unexpected error trying to get the order",
) => {
  return abortNavigation({
    message,
    statusCode: 500,
  });
};

export default defineNuxtRouteMiddleware(async (to) => {
  if (useError().value) return;

  const routeTrackingId = getQueryParamValue(to.params, "trackingId");

  if (!routeTrackingId) {
    return abortWithUnexpectedError(
      "EnsureOrderIsLoadedByTrackingIdMiddleware requires a route with trackingId parameter.",
    );
  }

  const pinia = usePinia();
  const order = useOrderStore(pinia);
  const { report } = useBugReporter();

  try {
    await order.loadFromTrackingId(routeTrackingId);
  } catch (error) {
    report(error, {
      tags: {
        "code.flag": "middleware-order",
      },
    });

    return abortWithUnexpectedError();
  }
});
